var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultRendererConfig } from "./index";
import { MESH_INDICES, MESH_VERTICES } from "./utils/standardPrimitiveData";
import { AnimationTrack } from "../framework/AnimationTrack";
import { EventAnimator } from "../framework/EventAnimator";
import { WaitAnimator } from "../framework/WaitAnimator";
import { objectLookAt } from "./utils/objectLookAt";
export function instancedMeshFlyover2(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Instanced Mesh Flyover 2" +
                "</h1>" +
                "<p>" +
                "The camera will be looking at an instanced mesh object. It should render normally with 5 instances." +
                "</p>";
        let object;
        yield objectLookAt(defaultRendererConfig(container), (renderer) => __awaiter(this, void 0, void 0, function* () {
            const mesh = renderer.createIndexedTriangleMesh();
            mesh.vertices = MESH_VERTICES;
            mesh.indices = MESH_INDICES;
            mesh.resolve();
            const material = {
                type: "basicOpaque",
                color: { r: 1, g: 1, b: 1 },
            };
            object = renderer.getObjectFactory().createRawInstancedMeshObject({
                position: {
                    cartographic: {
                        longitude: 2.633667667706,
                        latitude: -0.601510430485,
                        height: 5,
                    },
                },
                mesh,
                material,
                positions: [
                    { x: 0, y: 0, z: 0 },
                    { x: 5, y: 0, z: 0 },
                ],
                rotations: [
                    { x: 0, y: 0, z: 0, w: 0 },
                    { x: 0, y: 0, z: 0, w: 0 },
                ],
                scales: [
                    { x: 10, y: 1, z: 1 },
                    { x: 1, y: 1, z: 1 },
                ],
                colors: [
                    { r: 1, g: 0, b: 0 },
                    { r: 0, g: 1, b: 0 },
                ],
            });
            return object;
        }), undefined, () => {
            const track = new AnimationTrack();
            track.add(2, WaitAnimator.between);
            track.add(2, (beginTime, endTime) => EventAnimator.at(beginTime, endTime, (clock) => {
                object.positions = [{ x: 0, y: 0, z: 0 }];
                object.rotations = [{ x: 0, y: 0, z: 0, w: 0 }];
                object.scales = [{ x: 10, y: 1, z: 1 }];
                object.colors = [{ r: 1, g: 0, b: 0 }];
                object.resolve();
            }));
            track.add(2, WaitAnimator.between);
            track.add(2, (beginTime, endTime) => EventAnimator.at(beginTime, endTime, (clock) => {
                object.positions = [
                    { x: 0, y: 0, z: 0 },
                    { x: 5, y: 0, z: 0 },
                    { x: -5, y: 0, z: 0 },
                ];
                object.rotations = [
                    { x: 0, y: 0, z: 0, w: 0 },
                    { x: 0, y: 0, z: 0, w: 0 },
                    { x: 0, y: 0, z: 0, w: 0 },
                ];
                object.scales = [
                    { x: 10, y: 1, z: 1 },
                    { x: 1, y: 1, z: 1 },
                    { x: 1, y: 1, z: 1 },
                ];
                object.colors = [
                    { r: 1, g: 0, b: 0 },
                    { r: 0, g: 1, b: 0 },
                    { r: 0, g: 0, b: 1 },
                ];
                object.resolve();
            }));
            return [track];
        });
    });
}
